import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import "./gestion-types-unites.css";

//dev Extrem
import { Item as TabItem } from "devextreme-react/tab-panel";
import Form, { FormRef, GroupItem, Label, SimpleItem } from "devextreme-react/form";
import DataGrid, { Column, DataGridTypes, Editing, Lookup, MasterDetail, Pager, Paging } from 'devextreme-react/data-grid';

//models
import ITypeUnite from '../../models/ITypeUnite';
import Guid from "../../models/Guid";

//components
import MasterDetailGrid from './MaterialsGrid';
import { FormListBase, FormListBaseGrid, FormListBaseTab, FormListBaseToolbar } from '../base';
import { Button, DateBox, FileUploader, Gallery, NumberBox, SelectBox } from 'devextreme-react';

//hooks
import useLoadTypeUnite from './useLoadDataTypeUnite';
import useCustomDataSource, { IFormBaseDataSourceOptions, Mode } from "../../hooks/useCustomDataSource";
import useLookUpBase from '../../components/selectbox/LookupBase';
import FileUpload from '../../components/selectbox/FileUpload';
import FormSysteme from '../../components/forms/form-systeme';
import GestionMessages from "../gestion-messages/gestion-messages";
import GestionPlans from '../gestion-plans/gestion-plans';
import GestionCatalogueProduits from '../gestion-catalogue-produits/gestion-catalogue-produits';
import GestionTermesEtConditions from '../configuration/termesEtConditions';
import GestionGroupesTypesUnites from '../gestion-groupes-types-unites/gestion-groupes-types-unites';
import IGestionTypeUnite from '../../models/IGestionTypeUnite';
import GestionPlansSimple from '../gestion-plans/gestion-plans-simple';
import { useContextPopupPage } from '../../components/popups/PopupPage';

interface IGestionTypesUnitesProps {
  isModeSelection?: boolean,
}

export default function GestionTypesUnites({ isModeSelection }: IGestionTypesUnitesProps) {
  const typeUniteDataSourceOption: IFormBaseDataSourceOptions<IGestionTypeUnite> = useMemo(() => ({
    path: "typeUnite",
    customReadByIdPath: "typeUnite/{key}/gestion",
    customSauvegarderPath: "typeUnite/save",
    primaryKey: "idTypeUnite",
    includeInactives: true
  }), []);
  const typesUnitesFormDataSource = useCustomDataSource<ITypeUnite, IGestionTypeUnite>(typeUniteDataSourceOption);
  const { setMainForm, selectedDataRow: selectedTypeUnite, setSelectedDataRow, mode, setMode, isFieldModifier, onFieldDataChanged, setIsFieldModifier } = typesUnitesFormDataSource;
  const formRef = useRef<FormRef>(null);
  const setDataRow = (e: string) => {
    setSelectedDataRow((prev: IGestionTypeUnite) => (
      { ...prev, [e]: Guid.empty.toString() }
    ));
    setIsFieldModifier(true);
  }
  const dataGridFilterValue = useMemo(() => ["isDeleted", "anyof", [null, false]], []);
  const FileUploadIcone = FileUpload({
    currentSelected: selectedTypeUnite, dataField: "image", text: "Icône", isModeModifier: mode !== Mode.Lecture, controllerName: "planentete",
    setDataRow: () => setDataRow("image"),
    showClear: mode !== Mode.Lecture
  });
  const FileUploadSvg = FileUpload({
    currentSelected: selectedTypeUnite, dataField: "svg", text: "Carte svg", isModeModifier: mode !== Mode.Lecture, controllerName: "planentete",
    setDataRow: () => setDataRow("image"),
    showClear: mode !== Mode.Lecture
  });
  // const { editorOptions: fileUpload } = FileUpload({ isModeModifier:mode !== Mode.Lecture, controllerName: "planentete", setDataRow: () => setDataRow("image"), showClear: mode !== Mode.Lecture });
  const { editorOptions: planPourAnimauxEditorOption, PopupGestion: PopupGestionPlanPourAnimaux } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "planentete",
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idPlanEnteteAnimaux", Guid.empty.toString());
    },
    showClear: mode !== Mode.Lecture, width: '300px'
  });
  const { editorOptions: planForfaitEditorOptions, PopupGestion: GestionPlansForfaits } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "planentete",
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idPlanEntete", Guid.empty.toString());
    },
    showClear: mode !== Mode.Lecture
  });
  const { editorOptions: planParDefautEditorOption, PopupGestion: PopupGestionPlan } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "planentete",
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idPlanEntete", Guid.empty.toString());
    },
    showClear: mode !== Mode.Lecture, width: '300px'
  });
  // const { MessagesSelectBox } = useMessages();
  const { editorOptions: termesEtConditions, PopupGestion: PopupGestionTermeEtCondition } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: 'termeEtCondition',
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idTermeEtCondition", Guid.empty.toString());
    },
    width: '40%'
  })
  const { editorOptions: messageParDefautEditorOption } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "message",
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idMessage", Guid.empty.toString());
    },
    showClear: false, showFind: false, width: '300px'
  });
  const { editorOptions: planDureePlageEditorOptions, selectBox: planDureePlageSelectBox } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "planentete",
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idPlanEntete", Guid.empty.toString());
    },
    showClear: mode !== Mode.Lecture
  });
  const { editorOptions: produitPourOptionEditorOption, PopupGestion: PopupGestionCatalogue } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "catalogue",
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idProduitOption", Guid.empty.toString());
    },
    showClear: mode !== Mode.Lecture, width: '300px'
  });
  const { editorOptions: groupesTypesUnitesEditorOption, PopupGestion: PopupGestioGroupesTypesUnites } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: 'typeUniteGroupe',
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idTypeUniteGroupe", Guid.empty.toString());
    },
    showClear: mode !== Mode.Lecture, titre: "Gestion des groupes de types d'unités", width: '325px'
  });
  const { selectBox: TypePeroideSelectBox, editorOptions: typePeriodeEditorOptions } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: "typePeriodeCalendrier", showClear: mode !== Mode.Lecture });
  const { selectBox: typeCalculSelectBox, editorOptions: typeCalculEditorOptions } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: "TypeUniteDepotTypeCalcul", showClear: mode !== Mode.Lecture });
  const { selectBox: modeCalculSelectBox, editorOptions: modeCalculEditorOptions } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: "TypeUniteDepotModeCalcul", showClear: mode !== Mode.Lecture });
  const { editorOptions: planPersonneAdditionnelleEditorOption, PopupGestion: PopupGestionPlanPersonneAdditionnelle } = useLookUpBase({
    isModeModifier: mode !== Mode.Lecture, controllerName: "planentete",
    onClearRow: () => {
      setIsFieldModifier(true);
      formRef.current?.instance().updateData("idPlanEntetePersAdd", Guid.empty.toString());
    },
    showClear: mode !== Mode.Lecture, width: '300px'
  });
  const { selectBox: sourceMontantSelectBox, editorOptions: sourceMontantEditorOptions } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: "TypeUniteDepotSourceMontant", showClear: mode !== Mode.Lecture });
  const tempsItems = [
    { id: 0, text: "Jours" },
    { id: 1, text: "Semaine" },
    { id: 2, text: "Mois" },
  ];
  const typesOption = ["Aucun", "Type d'unité", "Unité", "Produit"];
  const [internetPhotos, setInternetPhotos] = useState<string[]>([])
  const [focusedPhoto, setFocusedPhoto] = useState<number | null>(null);
  const [iconesList, setIconesList] = useState<any[]>([]); // Future array for icons
  const { editorOptions: produitEditorOptions } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: "planentete", showClear: mode !== Mode.Lecture });
  const { editorOptions: planEnteteEditorOptions } = useLookUpBase({ isModeModifier: mode !== Mode.Lecture, controllerName: "planentete", showClear: mode !== Mode.Lecture });
  const {
    dataPeriode,
    dataForfait,
    dataSourceDepot,
    dataSourcePlageHoraire,
    dataSourcePlageHoraireDuree,
    _loadingDataTypeUnite,
    _getDataSourcePlageHoraireDuree
  } = useLoadTypeUnite(selectedTypeUnite?.idTypeUnite)

  const [dataSourcePlageHoraireDurees, setDataSourcePlageHoraireDuree] = useState<any[]>([])
  const [idPlageHoraireParent, setIdPlageHoraireParent] = useState<string>()
  const { setSelectedValue } = useContextPopupPage();

  useEffect(() => {
    setMainForm(formRef.current?.instance());
  })

  useEffect(() => {
    if (idPlageHoraireParent)
      (async () => {
        const data = await _getDataSourcePlageHoraireDuree();
        setDataSourcePlageHoraireDuree(data.filter((data) => data.idPlageHoraire === idPlageHoraireParent))
      })();
  }, [idPlageHoraireParent, selectedTypeUnite]);

  useEffect(() => {
    if (selectedTypeUnite) _loadingDataTypeUnite();
  }, [selectedTypeUnite])

  useEffect(() => {
    if (mode !== Mode.Lecture) formRef.current?.instance().getEditor("description")?.focus();
  }, [mode])

  const pageSizes = [10, 25, 50, 100];
  const jours = [
    { id: "Lundi", text: "Lundi" },
    { id: "Mardi", text: "Mardi" },
    { id: "Mercredi", text: "Mercredi" },
    { id: "Jeudi", text: "Jeudi" },
    { id: "Vendredi", text: "Vendredi" },
    { id: "Samedi", text: "Samedi" },
    { id: "Dimanche", text: "Dimanche" },
  ];
  // const jours = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];
  const { description, acombaEditorOptions, descriptionWebOptions, svgOptions, spinOptions2, spinOptions, typesOptionEditorOptions, joursReservationsOptions, dureeOptions, nbColonnesOptions, tailleColonneOptions, ordreAffichageOptions, delaiOptions, maxUnitesReservationOptions, maxJoursAvanceOptions, tempsOptions, datesOptions, calendrierEditorOptions, heuresOptions, heureDebutEditorOptions, dureePlageHoraireEditorOptions } = useMemo(() => {
    return {
      description: { width: 300 },
      acombaEditorOptions: { width: 225 },
      descriptionWebOptions: { height: 400, maxLength: 3000 },
      svgOptions: { maxLength: 50, width: '40%' },
      spinOptions2: { defaultValue: 1, min: 1, max: 999, showSpinButtons: true },
      spinOptions: { defaultValue: 0, min: 0, max: 999, width: '80px', showSpinButtons: true },
      typesOptionEditorOptions: { items: typesOption },
      joursReservationsOptions: { defaultValue: 1, min: 0, max: 999, width: '800px', showSpinButtons: true },
      dureeOptions: { width: '50px', defaultValue: 1, min: 1, max: 99, showSpinButtons: true },
      nbColonnesOptions: { width: '50px', defaultValue: 15, min: 1, max: 99, showSpinButtons: true },
      tailleColonneOptions: { defaultValue: 100, min: 1, max: 999, showSpinButtons: true, width: 100 },
      ordreAffichageOptions: { width: '50px', defaultValue: 1, min: 1, max: 99, showSpinButtons: true },
      delaiOptions: { defaultValue: 0, min: 0, max: 99, width: '90px', showSpinButtons: true },
      maxUnitesReservationOptions: { min: 0, max: 99, showSpinButtons: true },
      maxJoursAvanceOptions: { min: 0, max: 99, showSpinButtons: true, width: '90px' },
      tempsOptions: {
        width: 'max-content',
        items: tempsItems,
        valueExpr: "id",
        displayExpr: "text",
        defaultValue: tempsItems[0]?.id,
        showClearButton: true
      },
      calendrierEditorOptions: { defaultValue: new Date(), type: "date", width: 100, displayFormat: "dd-MMMM" },
      datesOptions: { defaultValue: new Date(), type: "date", width: 100, displayFormat: "dd-MMMM-yyyy" },
      heuresOptions: { width: 100, defaultValue: new Date().getTime(), type: "time" },
      heureDebutEditorOptions: { type: "time" },
      dureePlageHoraireEditorOptions: { defaultValue: 0, min: 0, max: 999, showSpinButtons: true }

    };
  }, []);

  const joursEditorOptions = {
    dataSource: [
      { id: "Lundi", text: "Lundi" },
      { id: "Mardi", text: "Mardi" },
      { id: "Mercredi", text: "Mercredi" },
      { id: "Jeudi", text: "Jeudi" },
      { id: "Vendredi", text: "Vendredi" },
      { id: "Samedi", text: "Samedi" },
      { id: "Dimanche", text: "Dimanche" },
    ],
    displayExpr: "text",
    valueExpr: "value"
  };

  const onSelectionchanged = (item: any, e: string) => {
    setIsFieldModifier(true);
    setSelectedDataRow((prev: IGestionTypeUnite) => {
      return { ...prev, [e]: item.id }
    })
  }

  const _onFocusedRowChanged = useCallback((e: DataGridTypes.FocusedRowChangedEvent) => {
    const idPlageHoraire = e?.row?.key
    setIdPlageHoraireParent(idPlageHoraire)

    const dataSource = dataSourcePlageHoraire.filter((idPlageHoraireDuree: string) => idPlageHoraireDuree === idPlageHoraire)
    setDataSourcePlageHoraireDuree(dataSource)
  }, [dataSourcePlageHoraire])

  return (
    <FormListBase data={typesUnitesFormDataSource}>
      <FormListBaseGrid dataSource={typesUnitesFormDataSource.dataSource}
        onFocusedRowChanged={(e: any) => {
          if (mode === Mode.Modifier)
            setMode(Mode.Lecture)
          if (setSelectedValue && e.row?.data)
            setSelectedValue(e.row.data);
        }}>
        <Column
          width={30}
          dataField="imageUrl"
          caption=''
          cellRender={(cellData) => (
            <img
              src={cellData.svg}
            />
          )}
        />
        {/* <Column width={30}>
          <SimpleItem>
            <Gallery
              disabled={mode === Mode.Lecture}
              className='gestion-types-unites-image'
              dataSource={[`${selectedTypeUnite.svg}`]}
              noDataText='Pas de données image'
              width={50}
              showIndicator={false}
            />
          </SimpleItem>
        </Column> */}
        <Column key={"grid-col-description"} dataField={"description"} caption="Description" allowHiding={false} />
        <Column key={"grid-col-ordreAffichage"} dataField={"ordreAffichage"} caption="Ordre Affichage" allowHiding={false} />
        <Column key={"grid-col-plan"} dataType="string" dataField={"idPlanEntete"}
          // cellRender={reservationCouleurGridCellItemRender}
          caption="Plan par défaut" allowHiding={false}>
          <Lookup {...produitEditorOptions} />
        </Column>
      </FormListBaseGrid>
      <FormListBaseToolbar headerText={`${selectedTypeUnite?.description || ''}`} sauvegarderOptions={{ disabled: !isFieldModifier }} annulerOptions={{ disabled: !isFieldModifier }} />
      {!isModeSelection || isModeSelection && mode !== Mode.Lecture
        ? <FormListBaseTab>
          <PopupGestioGroupesTypesUnites
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idTypeUniteGroupe", data.idTypeUniteGroupe);
            }}
          >
            <GestionGroupesTypesUnites isModeSelection={true} />
          </PopupGestioGroupesTypesUnites>
          <PopupGestionCatalogue
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idProduitOption", data.idProduit);
            }}
          >
            <GestionCatalogueProduits isModeSelection={true} />
          </PopupGestionCatalogue>
          <PopupGestionPlan
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idPlanEntete", data.idPlanEntete);
            }}
          >
            <GestionPlans isModeSelection={true} />
          </PopupGestionPlan>
          <PopupGestionTermeEtCondition
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idTermeEtCondition", data.idTermeEtCondition);
            }}>
            <GestionTermesEtConditions isModeSelection={true} />
          </PopupGestionTermeEtCondition>
          <PopupGestionPlanPersonneAdditionnelle
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idPlanEntetePersAdd", data.idPlanEntete);
            }}
          >
            <GestionPlansSimple isModeSelection={true} />
          </PopupGestionPlanPersonneAdditionnelle>
          <PopupGestionPlanPourAnimaux
            onSelectionchanged={(data: any) => {
              setIsFieldModifier(true);
              formRef.current?.instance().updateData("idPlanEnteteAnimaux", data.idPlanEntete);
            }}
          >
            <GestionPlansSimple isModeSelection={true} />
          </PopupGestionPlanPourAnimaux>
          <TabItem title="Informations">
            <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={false} formData={selectedTypeUnite || {} as ITypeUnite} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
              <GroupItem alignItemLabels={true}>
                <SimpleItem key={"frm-description"} dataField={"description"} editorOptions={description} />
                <SimpleItem key={"frm-description-en"} dataField={"descriptionAnglaise"} editorOptions={description}>
                  <Label text={'Description anglaise'} />
                </SimpleItem>
                <SimpleItem key={"frm-plan"}
                  dataField={"idPlanEntete"}
                  editorType={"dxSelectBox"}
                  editorOptions={planParDefautEditorOption}
                >
                  <Label text={"Plan par défaut"} />
                </SimpleItem>
                <SimpleItem key={"frm-plan-personnes-additionelles"}
                  dataField={"idPlanEntetePersAdd"}
                  editorType={"dxSelectBox"}
                  editorOptions={planPersonneAdditionnelleEditorOption}
                >
                  <Label text={"Plan pour personnes additionnelles"} />
                </SimpleItem>
                <SimpleItem key={"frm-message"}
                  dataField={"idMessage"}
                  editorType={"dxSelectBox"}
                  // render={MessagesSelectBox}
                  editorOptions={messageParDefautEditorOption}
                >
                  <Label text={"Message par défaut"} />
                </SimpleItem>
                <SimpleItem key={"frm-produits"}
                  dataField={"idProduitOption"}
                  editorType={"dxSelectBox"}
                  editorOptions={produitPourOptionEditorOption}
                >
                  <Label text={"Produits pour les options"} />
                </SimpleItem>
                <SimpleItem key={"frm-acomba"} dataField={"acombaProjet"} editorOptions={acombaEditorOptions}
                >
                  <Label text={"Numéro projet acomba"} />
                </SimpleItem>
                <SimpleItem key={"frm-animaux"} dataField={"nombreAnimauxMax"} editorType={"dxNumberBox"} editorOptions={spinOptions}>
                  <Label text={"Nombre d'animaux maximum"} />
                </SimpleItem>
                <SimpleItem key={"frm-plan-animaux"}
                  dataField={"idPlanEnteteAnimaux"}
                  editorType={"dxSelectBox"}
                  editorOptions={planPourAnimauxEditorOption}
                >
                  <Label text={"Plan pour animaux"} />
                </SimpleItem>
              </GroupItem>
              <GroupItem colCount={2} caption="Options" alignItemLabels={true}
              >
                {/* <div className="dx-fieldset">
                    <div className="dx-field">
                      <div className="dx-field-label">Checked</div>
                      <div className="dx-field-value"></div>
                      <CheckBox defaultValue={true} disabled={false} value={null} />
                    </div>
                  </div> */}
                {/* <div className="dx-field-label">
                    <CheckBox defaultValue={true} disabled={false} value={true} />
                    Actif
                  </div> */}
                <SimpleItem key={"frm-actif"} dataField={"actif"} editorType={"dxCheckBox"} />
                <SimpleItem key={"frm-séjour"} dataField={"sejour"} editorType={"dxCheckBox"}>
                  <Label text={"Séjour"} />
                </SimpleItem>
                <SimpleItem key={"frm-inclure"} dataField={"inclureCalculTauxOccupation"} editorType={"dxCheckBox"}>
                  <Label text={"Inclure dans le calcul de taux occupation"} />
                </SimpleItem>
                <SimpleItem key={"frm-annuel"} dataField={"annuel"} editorType={"dxCheckBox"}>
                  <Label text={"Annuel / Saisonnier"} />
                </SimpleItem>
                <SimpleItem key={"frm-hébergement"} dataField={"genererDateCommeHebergTaxab"} editorType={"dxCheckBox"}>
                  <Label text={"Générer les dates comme un hébergement (séjour)"} />
                </SimpleItem>
                <SimpleItem key={"frm-taxable"} dataField={"hebergementTaxable"} editorType={"dxCheckBox"}>
                  <Label text={"Hébergement taxable"} />
                </SimpleItem>
                <SimpleItem key={"frm-age"} dataField={"nePasDemanderTranchesAges"} editorType={"dxCheckBox"}>
                  <Label text={"Ne pas demander les tranches d'âges"} />
                </SimpleItem>
                <SimpleItem key={"frm-heure"} dataField={"cacherHeures"} editorType={"dxCheckBox"}>
                  <Label text={"Ne pas afficher les heures"} />
                </SimpleItem>
              </GroupItem>
              <GroupItem caption="Affichage calendrier" alignItemLabels={true}
              // colCount={2}
              >
                {/* {FileUploadIcone} */}
                {/* <SimpleItem key={"frm-icone-upload"}
                      dataField={"image"}
                      editorType={"dxFileUploader"}
                      editorOptions={fileUpload}
                    >
                      <Label text={"Icône"} />
                    </SimpleItem> */}

                {/* <SimpleItem colSpan={2}>
                  <Label text='Icône' />
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Gallery
                      disabled={mode === Mode.Lecture}
                      className='gestion-types-unites-image'
                      dataSource={selectedTypeUnite?.image ? [`${selectedTypeUnite.image}`] : []}
                      noDataText='Pas de données image'
                      width={25}
                      height={25}
                      showIndicator={false}
                    />
                    <FileUploader
                      className='unites-dx-fileuploader'
                      disabled={mode === Mode.Lecture}
                      onValueChange={async (e) => {
                        if (e?.[0]) {
                          const file = e[0];
                          const fr = new FileReader();
                          await fr.readAsDataURL(file);
                          fr.onload = () => {
                            if (fr.result) {
                              const base64 = fr.result.toString();
                              setSelectedDataRow((prev: IGestionTypeUnite) => (
                                { ...prev, image: base64 }
                              ));
                              setIsFieldModifier(true);
                            }
                          };
                        } else {
                          alert("File not selected or browser incompatible.")
                        }
                      }}
                      showFileList={false}
                      selectButtonText="+"
                      labelText=""
                      accept="image/*"
                      uploadMode="useForm"
                    />
                    <Button
                      disabled={mode === Mode.Lecture}
                      className='removeButton'
                      onClick={() => {
                        setSelectedDataRow((prev: IGestionTypeUnite) => (
                          { ...prev, image: "" }
                        ));
                        setIsFieldModifier(true);
                      }}
                      text="X"
                    />
                  </div>
                </SimpleItem> */}



                <SimpleItem colSpan={2}>
                  <Label text='Icône' />
                  <div className="icone-select-container">
                    {selectedTypeUnite?.image && (
                      <img
                        src={selectedTypeUnite.image}
                        alt="Icon"
                        style={{ width: '20px', height: '20px', objectFit: 'contain' }}
                      />
                    )}
                    <SelectBox
                      value={selectedTypeUnite?.image}
                      dataSource={iconesList}
                      displayExpr="text"
                      valueExpr="value"
                      disabled={mode === Mode.Lecture}
                      placeholder="Sélectionner une icône"
                      onValueChanged={(e) => {
                        if (e.value) {
                          const formInstance = formRef.current?.instance();
                          formInstance?.updateData("image", e.value);
                          setSelectedDataRow((prev: IGestionTypeUnite) => (
                            { ...prev, image: e.value }
                          ));
                          setIsFieldModifier(true);
                        }
                      }}
                      stylingMode="filled"
                      showClearButton={false}
                    />
                    <FileUploader
                      disabled={mode === Mode.Lecture}
                      onValueChange={async (e) => {
                        if (e?.[0]) {
                          const file = e[0];
                          const fr = new FileReader();
                          await fr.readAsDataURL(file);
                          fr.onload = () => {
                            if (fr.result) {
                              const base64 = fr.result.toString();
                              setSelectedDataRow((prev: IGestionTypeUnite) => (
                                { ...prev, image: base64 }
                              ));
                              setIsFieldModifier(true);
                            }
                          };
                        } else {
                          alert("File not selected or browser incompatible.")
                        }
                      }}
                      showFileList={false}
                      selectButtonText="+"
                      labelText=""
                      accept="image/*"
                      uploadMode="useForm"
                    />
                    {selectedTypeUnite?.image && (
                      <Button
                        disabled={mode === Mode.Lecture}
                        onClick={() => {
                          setSelectedDataRow((prev: IGestionTypeUnite) => (
                            { ...prev, image: "" }
                          ));
                          setIsFieldModifier(true);
                        }}
                        text="X"
                      />
                    )}
                  </div>
                </SimpleItem>

                {/* <SimpleItem>
                      {selectedTypeUnite.image &&
                        <Button
                          id="saveButton"
                          style={{
                            backgroundImage: `url(${selectedTypeUnite.image})`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "2px 6px",
                            paddingLeft: "10px"
                          }}
                          // className='gestion-types-unites-icon'
                          text="+"
                        />
                      }
                    </SimpleItem> */}

                <SimpleItem key={"frm-duree"}>
                  <Label text={"Durée période"} />
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <NumberBox
                      value={selectedTypeUnite?.dureePeriode}
                      onValueChanged={(e) => {
                        const formInstance = formRef.current?.instance();
                        formInstance?.updateData("dureePeriode", e.value);
                        setSelectedDataRow((prev: IGestionTypeUnite) => (
                          { ...prev, dureePeriode: e.value }
                        ));
                        setIsFieldModifier(true);
                      }}
                      disabled={mode === Mode.Lecture}
                      {...dureeOptions}
                    />
                    <SelectBox
                      value={selectedTypeUnite?.typePeriode}
                      onValueChanged={(e) => {
                        const formInstance = formRef.current?.instance();
                        formInstance?.updateData("typePeriode", e.value);
                        setSelectedDataRow((prev: IGestionTypeUnite) => (
                          { ...prev, typePeriode: e.value }
                        ));
                        setIsFieldModifier(true);
                      }}
                      disabled={mode === Mode.Lecture}
                      {...tempsOptions}
                    />
                  </div>
                </SimpleItem>
                <SimpleItem key={"frm-afficher"} colSpan={2}>
                  <Label text={"Afficher:"} />
                  <div style={{
                    display: 'flex', alignItems: 'center',
                    gap: '5px'
                  }}>
                    <NumberBox
                      value={selectedTypeUnite?.nombreColonnes}
                      onValueChanged={(e) => {
                        const formInstance = formRef.current?.instance();
                        formInstance?.updateData("nombreColonnes", e.value);
                        setSelectedDataRow((prev: IGestionTypeUnite) => (
                          { ...prev, nombreColonnes: e.value }
                        ));
                        setIsFieldModifier(true);
                      }}
                      disabled={mode === Mode.Lecture}
                      {...nbColonnesOptions}
                    />
                    <span>colonnes</span>
                  </div>
                </SimpleItem>
                <SimpleItem key={"frm-dateDebut"} colSpan={2}>
                  <Label text={"Date de début"} />
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <DateBox
                      value={selectedTypeUnite?.calDateDebut}
                      onValueChanged={(e) => {
                        if (!e.value) return;
                        const formInstance = formRef.current?.instance();
                        const currentValue = selectedTypeUnite?.calDateDebut;
                        if (!currentValue) return;
                        const newDate = e.value;
                        if (newDate instanceof Date && currentValue instanceof Date) {
                          const updatedDate = new Date(newDate);
                          updatedDate.setHours(currentValue.getHours(), currentValue.getMinutes(), currentValue.getSeconds(), currentValue.getMilliseconds());
                          const dateChanged = updatedDate.getFullYear() !== currentValue.getFullYear() ||
                            updatedDate.getMonth() !== currentValue.getMonth() ||
                            updatedDate.getDate() !== currentValue.getDate();
                          if (dateChanged) {
                            formInstance?.updateData("calDateDebut", updatedDate);
                            setSelectedDataRow((prev: IGestionTypeUnite) => (
                              { ...prev, calDateDebut: updatedDate }
                            ));
                            setIsFieldModifier(true);
                          }
                        }
                      }}
                      disabled={mode === Mode.Lecture}
                      type="date"
                      width={100}
                      displayFormat="dd-MMMM"
                    />
                    <DateBox
                      value={selectedTypeUnite?.calDateDebutInternet}
                      onValueChanged={(e) => {
                        if (!e.value) return;
                        const formInstance = formRef.current?.instance();
                        const currentValue = selectedTypeUnite?.calDateDebutInternet;
                        if (!currentValue) return;
                        const newTime = e.value;
                        if (newTime instanceof Date && currentValue instanceof Date) {
                          const updatedDate = new Date(currentValue);
                          updatedDate.setHours(newTime.getHours(), newTime.getMinutes(), newTime.getSeconds(), newTime.getMilliseconds());
                          const timeChanged = updatedDate.getHours() !== currentValue.getHours() ||
                            updatedDate.getMinutes() !== currentValue.getMinutes() ||
                            updatedDate.getSeconds() !== currentValue.getSeconds();
                          if (timeChanged) {
                            formInstance?.updateData("calDateDebutInternet", updatedDate);
                            setSelectedDataRow((prev: IGestionTypeUnite) => (
                              { ...prev, calDateDebutInternet: updatedDate }
                            ));
                            setIsFieldModifier(true);
                          }
                        }
                      }}
                      disabled={mode === Mode.Lecture}
                      type="time"
                      width={100}
                    />
                  </div>
                </SimpleItem>
                <SimpleItem key={"frm-dateFin"} colSpan={2}>
                  <Label text={"Date de fin"} />
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <DateBox
                      value={selectedTypeUnite?.calDateFin}
                      onValueChanged={(e) => {
                        if (!e.value) return;
                        const formInstance = formRef.current?.instance();
                        const currentValue = selectedTypeUnite?.calDateFin;
                        if (!currentValue) return;
                        const newDate = e.value;
                        if (newDate instanceof Date && currentValue instanceof Date) {
                          const updatedDate = new Date(newDate);
                          updatedDate.setHours(currentValue.getHours(), currentValue.getMinutes(), currentValue.getSeconds(), currentValue.getMilliseconds());
                          const dateChanged = updatedDate.getFullYear() !== currentValue.getFullYear() ||
                            updatedDate.getMonth() !== currentValue.getMonth() ||
                            updatedDate.getDate() !== currentValue.getDate();
                          if (dateChanged) {
                            formInstance?.updateData("calDateFin", updatedDate);
                            setSelectedDataRow((prev: IGestionTypeUnite) => (
                              { ...prev, calDateFin: updatedDate }
                            ));
                            setIsFieldModifier(true);
                          }
                        }
                      }}
                      disabled={mode === Mode.Lecture}
                      type="date"
                      width={100}
                      displayFormat="dd-MMMM"
                    />
                    <DateBox
                      value={selectedTypeUnite?.calDateFinInternet}
                      onValueChanged={(e) => {
                        if (!e.value) return;
                        const formInstance = formRef.current?.instance();
                        const currentValue = selectedTypeUnite?.calDateFinInternet;
                        if (!currentValue) return;
                        const newTime = e.value;
                        if (newTime instanceof Date && currentValue instanceof Date) {
                          const updatedDate = new Date(currentValue);
                          updatedDate.setHours(newTime.getHours(), newTime.getMinutes(), newTime.getSeconds(), newTime.getMilliseconds());
                          const timeChanged = updatedDate.getHours() !== currentValue.getHours() ||
                            updatedDate.getMinutes() !== currentValue.getMinutes() ||
                            updatedDate.getSeconds() !== currentValue.getSeconds();
                          if (timeChanged) {
                            formInstance?.updateData("calDateFinInternet", updatedDate);
                            setSelectedDataRow((prev: IGestionTypeUnite) => (
                              { ...prev, calDateFinInternet: updatedDate }
                            ));
                            setIsFieldModifier(true);
                          }
                        }
                      }}
                      disabled={mode === Mode.Lecture}
                      type="time"
                      width={100}
                    />
                  </div>
                </SimpleItem>
                <SimpleItem key={"frm-taille-colonne"} dataField={"tailleColonne"} editorType={"dxNumberBox"} editorOptions={tailleColonneOptions}>
                  <Label text={"Taille colonne"} />
                </SimpleItem>
                <SimpleItem key={"frm-ordre-affichage"} dataField={"ordreAffichage"} editorType={"dxNumberBox"} editorOptions={ordreAffichageOptions}>
                  <Label text={"Ordre d'affichage"} />
                </SimpleItem>
                <SimpleItem
                  key={"frm-idTypeUniteGroupe"}
                  dataField={"idTypeUniteGroupe"}
                  editorType={"dxSelectBox"}
                  editorOptions={groupesTypesUnitesEditorOption}
                  colSpan={2}
                >
                  <Label text={"Groupe"} />
                </SimpleItem>
                {/* {FileUploadSvg} */}
                <SimpleItem colSpan={2}>
                  <Label text='Carte svg' />
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <FileUploader
                      disabled={mode === Mode.Lecture}
                      width={150}
                      onValueChange={async (e) => {
                        if (e?.[0]) {
                          const file = e[0];
                          const fr = new FileReader();
                          await fr.readAsDataURL(file);
                          fr.onload = () => {
                            if (fr.result) {
                              const base64 = fr.result.toString();
                              setSelectedDataRow((prev: IGestionTypeUnite) => (
                                { ...prev, svg: base64 }
                              ));
                              setIsFieldModifier(true);
                            }
                          };
                        } else {
                          alert("File not selected or browser incompatible.")
                        }
                      }}
                      showFileList={false}
                      selectButtonText="Parcourir..."
                      labelText=""
                      accept="image/*"
                      uploadMode="useForm"
                    />
                    <Gallery
                      disabled={mode === Mode.Lecture}
                      className='gestion-types-unites-image'
                      dataSource={selectedTypeUnite?.svg ? [`${selectedTypeUnite.svg}`] : []}
                      noDataText='Pas de données image'
                      width={50}
                      height={50}
                      showIndicator={false}
                    />
                    <Button
                      disabled={mode === Mode.Lecture}
                      onClick={() => {
                        setSelectedDataRow((prev: IGestionTypeUnite) => (
                          { ...prev, svg: "" }
                        ));
                        setIsFieldModifier(true);
                      }}
                      text="X"
                    />
                  </div>
                </SimpleItem>
                <SimpleItem key={"frm-apercu-carte"} colSpan={2}>
                  <Label text={"Aperçu de la carte"} />
                  <Gallery
                    disabled={mode === Mode.Lecture}
                    className='gestion-types-unites-image'
                    dataSource={selectedTypeUnite?.svg ? [`${selectedTypeUnite.svg}`] : []}
                    noDataText='Pas de données image'
                    width={100}
                    height={100}
                    showIndicator={false}
                  />
                </SimpleItem>
              </GroupItem>

            </Form>
          </TabItem>
          <TabItem title="Dépôts">
            <div style={{ display: "flex" }}>
              <div style={{ width: "100%" }}>
                <DataGrid
                  // keyExpr="idTypeUniteDepot"
                  // dataSource={dataSourceDepot.depot}
                  // allowColumnReordering={true}
                  // rowAlternationEnabled={true}
                  // onContentReady={onContentReady}
                  showBorders={true}
                  allowColumnResizing={true}
                  dataSource={selectedTypeUnite.depots}
                  allowColumnReordering={false}
                  filterValue={dataGridFilterValue}
                  noDataText={""}
                  onInitNewRow={(e: any) => {
                    e.data.idTypeUnite = selectedTypeUnite.idTypeUnite;
                    e.data.isDeleted = false;
                  }}
                  onEditorPreparing={(e: any) => {
                    const originalOnValueChanged = e.editorOptions.onValueChanged;
                    e.editorOptions.onValueChanged = (args: any) => {
                      if (originalOnValueChanged) {
                        originalOnValueChanged(args);
                      }

                      const currentData = e.component.option("dataSource");
                      const rowIndex = e.rowIndex;
                      const rowData = currentData[rowIndex];

                      const updatedData = currentData.filter((_: any, index: any) => index !== rowIndex);
                      setSelectedDataRow(prev => ({
                        ...prev,
                        depots: updatedData
                      }));
                      setIsFieldModifier(true);
                    }
                  }}
                  onRowRemoving={async (e) => {
                    e.cancel = true;
                    // if (e?.data?.idPermisType) {
                    const index = selectedTypeUnite.depots.findIndex(item =>
                      item.idDepot?.equals(e.data.idDepot)
                    );
                    if (index !== -1) {
                      const updatedData = [...selectedTypeUnite.depots];
                      updatedData[index] = { ...updatedData[index], isDeleted: true };
                      setSelectedDataRow(prev => ({
                        ...prev,
                        depots: updatedData
                      }));
                    }
                    // }
                  }}
                >
                  <Editing
                    mode="cell"
                    allowUpdating={mode !== Mode.Lecture}
                    allowDeleting={mode !== Mode.Lecture}
                    allowAdding={mode !== Mode.Lecture}
                    newRowPosition={"first"}
                    startEditAction={"click"}
                  />
                  <MasterDetail
                    enabled={true}
                    component={MasterDetailGrid}
                  />
                  {/* <GroupPanel visible={true} />
                <SearchPanel visible={true} highlightCaseSensitive={true} />
                <Grouping autoExpandAll={false} /> */}

                  {/* <Column dataField="Product" /> */}
                  <Column
                    dataField="priorite"
                    caption="Priorité"
                    dataType="number"
                    alignment="left"
                    allowEditing={false}
                  />
                  <Column
                    dataField="modeCalcul"
                    caption="Mode de Calcul"
                    // dataType="number"
                    // format="percent"
                    alignment="left"
                    allowGrouping={false}
                    // cellRender={modeCalculSelectBox}
                    cssClass="bullet"
                  >
                    <Lookup {...modeCalculEditorOptions} />
                  </Column>
                  <Column dataField="montantDepot" dataType="number" caption="Source du Montant"
                  // cellRender={sourceMontantSelectBox}
                  >
                    {/* <Lookup {...sourceMontantEditorOptions} /> */}
                  </Column>
                  {/* <Column dataField="depotFixe" dataType="boolean" caption="Type de Calcul">
                    <Lookup {...typeCalculEditorOptions} />
                  </Column> */}
                  <Column dataField="reservationMontantInferieurA" dataType="number" caption="Montant Réservation <= a" format="currency" />
                  <Column dataField="reservationNombreJoursInferieurA" dataType="number" caption="Nb. Jours <= a" />
                  <Column dataField="depotSejourSeulement" dataType="boolean" caption="Séjours Seulement" />
                  <Column dataField="depotWeb" dataType="boolean" caption="Dépôt Web" />
                  <Column dataField="isDeleted" dataType="boolean" visible={false} />
                </DataGrid>
              </div>
            </div>
          </TabItem>
          <TabItem title="Options">
            <div style={{ display: "flex" }}>
              <div style={{ width: "100%" }}>
                <DataGrid
                  showBorders={true}
                  dataSource={selectedTypeUnite.options}
                  allowColumnReordering={false}
                  filterValue={dataGridFilterValue}
                  height={"100%"}
                  noDataText={"Aucune date d'indisponibilité"}
                  onInitNewRow={(e: any) => {
                    e.data.idTypeUnite = selectedTypeUnite.idTypeUnite;
                    e.data.isDeleted = false;
                  }}
                  onEditorPreparing={(e: any) => {
                    const originalOnValueChanged = e.editorOptions.onValueChanged;
                    e.editorOptions.onValueChanged = (args: any) => {
                      if (originalOnValueChanged) {
                        originalOnValueChanged(args);
                      }

                      const currentData = e.component.option("dataSource");
                      const rowIndex = e.rowIndex;
                      const rowData = currentData[rowIndex];

                      const updatedData = currentData.filter((_: any, index: any) => index !== rowIndex);
                      setSelectedDataRow(prev => ({
                        ...prev,
                        options: updatedData
                      }));
                      setIsFieldModifier(true);
                    };
                  }}
                  onRowRemoving={async (e) => {
                    e.cancel = true;
                    const index = selectedTypeUnite.options.findIndex(item =>
                      item.idOptionReservation?.equals(e.data.idOptionReservation)
                    );
                    if (index !== -1) {
                      const updatedData = [...selectedTypeUnite.options];
                      updatedData[index] = { ...updatedData[index], isDeleted: true };
                      setSelectedDataRow(prev => ({
                        ...prev,
                        options: updatedData
                      }));
                    }
                  }}
                >
                  <Editing
                    mode="cell"
                    allowUpdating={mode !== Mode.Lecture}
                    allowDeleting={mode !== Mode.Lecture}
                    allowAdding={mode !== Mode.Lecture}
                    newRowPosition={"first"}
                    startEditAction={"click"}
                  />
                  {/* <MasterDetail
                    enabled={true}
                    component={MasterDetailGrid}
                  /> */}
                  {/* <GroupPanel visible={true} />
                <SearchPanel visible={true} highlightCaseSensitive={true} />
                <Grouping autoExpandAll={false} /> */}

                  {/* <Column dataField="Product" /> */}
                  <Column dataField="description" dataType="string" alignment="left" />
                  <Column
                    dataField="typeOption"
                    caption="Type d'option"
                    dataType="string"
                    alignment="left"
                    editorOptions={typesOptionEditorOptions}
                  >
                    {/* <Lookup {...typesOption} /> */}
                  </Column>
                  <Column dataField="element" dataType="string" caption="Élément"
                  >
                  </Column>
                  <Column dataField="depotFixe" dataType="string" caption="Mode de calcul">
                    <Lookup {...modeCalculEditorOptions} />
                  </Column>
                  <Column dataField="typeChamp" dataType="string" caption="Type de champ">
                  </Column>
                  <Column dataField="quantiteMax" dataType="number" caption="Quantité Max." alignment='left' />
                  <Column dataField="ajout" dataType="boolean" caption="Ajout Automatique" />
                  <Column dataField="sejour" dataType="boolean" caption="Séjour complet" />
                  <Column width={75} dataField="internet" dataType="boolean" caption="Internet" />
                  <Column width={75} dataField="logiciel" dataType="boolean" caption="Logiciel" />
                  <Column dataField="isDeleted" dataType="boolean" visible={false} />
                  <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
                  <Paging defaultPageSize={10} />
                </DataGrid>
              </div>
            </div>
          </TabItem>
          <TabItem title="Plage horaire">
            <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedTypeUnite || {} as ITypeUnite} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
              <SimpleItem key={"frm-délai"} dataField={"delaiEntreDeparts"} editorType={"dxNumberBox"} editorOptions={delaiOptions}>
                <Label text={"Délai (minutes) entre les départs"} />
              </SimpleItem>
              <GroupItem colCount={2}>
                <GroupItem caption={"Plages"} colSpan={1}>
                  <GroupItem>
                    <DataGrid
                      // keyExpr="idPlageHoraire"
                      // showBorders={true}
                      // allowColumnResizing={true}
                      // focusedRowEnabled={true} // ligne cible active
                      // onFocusedRowChanged={_onFocusedRowChanged}
                      // focusedRowIndex={1}
                      // dataSource={dataSourcePlageHoraire}


                      showBorders={true}
                      dataSource={selectedTypeUnite.plagesHoraire}
                      allowColumnReordering={false}
                      filterValue={dataGridFilterValue}
                      height={"100%"}
                      noDataText={"Aucune plage horaire"}
                      onInitNewRow={(e: any) => {
                        e.data.idTypeUnite = selectedTypeUnite.idTypeUnite;
                        e.data.isDeleted = false;
                      }}
                      onEditorPreparing={(e: any) => {
                        const originalOnValueChanged = e.editorOptions.onValueChanged;
                        e.editorOptions.onValueChanged = (args: any) => {
                          if (originalOnValueChanged) {
                            originalOnValueChanged(args);
                          }

                          const currentData = e.component.option("dataSource");
                          const rowIndex = e.rowIndex;
                          const rowData = currentData[rowIndex];

                          const updatedData = currentData.filter((_: any, index: any) => index !== rowIndex);
                          setSelectedDataRow(prev => ({
                            ...prev,
                            plagesHoraire: updatedData
                          }));
                          setIsFieldModifier(true);
                        };
                      }}
                      onRowRemoving={async (e) => {
                        e.cancel = true;
                        const index = selectedTypeUnite.plagesHoraire.findIndex(item =>
                          item.idPlageHoraire.equals(e.data.idPlageHoraire)
                        );
                        if (index !== -1) {
                          const updatedData = [...selectedTypeUnite.plagesHoraire];
                          updatedData[index] = { ...updatedData[index], isDeleted: true };
                          setSelectedDataRow(prev => ({
                            ...prev,
                            plagesHoraire: updatedData
                          }));
                        }
                      }}
                    >
                      <Editing
                        mode="cell"
                        allowUpdating={mode !== Mode.Lecture}
                        allowDeleting={mode !== Mode.Lecture}
                        allowAdding={mode !== Mode.Lecture}
                        newRowPosition={"first"}
                        startEditAction={"click"}
                      />
                      <Column dataField="debut"
                        caption="Heure de début"
                        dataType="datetime"
                        format='shortTime'
                        alignment="left" editorOptions={heureDebutEditorOptions} />
                      <Column dataField="isDeleted" dataType="boolean" visible={false} />
                    </DataGrid>
                  </GroupItem>
                </GroupItem>
                <GroupItem caption={"Durée de la plage selectionnée"}
                  colSpan={1}
                >
                  <GroupItem>
                    <DataGrid
                      // keyExpr="idPlageHoraire"
                      allowColumnResizing={true}
                      showBorders={true}
                      dataSource={selectedTypeUnite.plagesHoraireDuree}
                      allowColumnReordering={false}
                      filterValue={dataGridFilterValue}
                      height={"100%"}
                      noDataText={"Aucune plage horaire"}
                      onInitNewRow={(e: any) => {
                        e.data.idTypeUnite = selectedTypeUnite.idTypeUnite;
                        e.data.isDeleted = false;
                      }}
                      onEditorPreparing={(e: any) => {
                        const originalOnValueChanged = e.editorOptions.onValueChanged;
                        e.editorOptions.onValueChanged = (args: any) => {
                          if (originalOnValueChanged) {
                            originalOnValueChanged(args);
                          }

                          const currentData = e.component.option("dataSource");
                          const rowIndex = e.rowIndex;
                          const rowData = currentData[rowIndex];

                          const updatedData = currentData.filter((_: any, index: any) => index !== rowIndex);
                          setSelectedDataRow(prev => ({
                            ...prev,
                            plagesHoraireDuree: updatedData
                          }));
                          setIsFieldModifier(true);
                        };
                      }}
                      onRowRemoving={async (e) => {
                        e.cancel = true;
                        const index = selectedTypeUnite.plagesHoraireDuree.findIndex(item =>
                          item.idPlageHoraire.equals(e.data.idPlageHoraire)
                        );
                        if (index !== -1) {
                          const updatedData = [...selectedTypeUnite.plagesHoraireDuree];
                          updatedData[index] = { ...updatedData[index], isDeleted: true };
                          setSelectedDataRow(prev => ({
                            ...prev,
                            plagesHoraireDuree: updatedData
                          }));
                        }
                      }}
                    >
                      <Editing
                        mode="cell"
                        allowUpdating={mode !== Mode.Lecture}
                        allowDeleting={mode !== Mode.Lecture}
                        allowAdding={mode !== Mode.Lecture}
                        newRowPosition={"first"}
                        startEditAction={"click"}
                      />
                      <Column dataField="duree" caption="Durée" dataType="number" alignment="left"
                        editorOptions={dureePlageHoraireEditorOptions} /> {/**dataField absent dans la reponse de l'api */}
                      <Column dataField="typePeriode" dataType="string" caption="Type de période">
                        <Lookup {...typePeriodeEditorOptions} />
                      </Column>
                      <Column dataField="idPlanEntete" caption="Plan">
                        <Lookup {...planDureePlageEditorOptions} />
                      </Column>
                      <Column dataField="isDeleted" dataType="boolean" visible={false} />
                    </DataGrid>
                  </GroupItem>
                </GroupItem>
              </GroupItem>
            </Form>
          </TabItem>
          <TabItem title="Forfaits">
            <DataGrid
              width={'60%'}
              rowAlternationEnabled={true}
              allowColumnResizing={true}
              showBorders={true}
              dataSource={selectedTypeUnite.forfaits}
              allowColumnReordering={false}
              filterValue={dataGridFilterValue}
              height={"100%"}
              noDataText={"Aucune plage horaire"}
              onInitNewRow={(e: any) => {
                e.data.idTypeUnite = selectedTypeUnite.idTypeUnite;
                e.data.isDeleted = false;
              }}
              onEditorPreparing={(e: any) => {
                const originalOnValueChanged = e.editorOptions.onValueChanged;
                e.editorOptions.onValueChanged = (args: any) => {
                  if (originalOnValueChanged) {
                    originalOnValueChanged(args);
                  }

                  const currentData = e.component.option("dataSource");
                  const rowIndex = e.rowIndex;
                  const rowData = currentData[rowIndex];

                  const updatedData = currentData.filter((_: any, index: any) => index !== rowIndex);
                  setSelectedDataRow(prev => ({
                    ...prev,
                    forfaits: updatedData
                  }));
                  setIsFieldModifier(true);
                };
              }}
              onRowRemoving={async (e) => {
                e.cancel = true;
                const index = selectedTypeUnite.forfaits.findIndex(item =>
                  item.idTypeUniteForfait && e.data.idTypeUniteForfait && item.idTypeUniteForfait.equals(e.data.idTypeUniteForfait)
                );
                if (index !== -1) {
                  const updatedData = [...selectedTypeUnite.forfaits];
                  updatedData[index] = { ...updatedData[index], isDeleted: true };
                  setSelectedDataRow(prev => ({
                    ...prev,
                    forfaits: updatedData
                  }));
                }
              }}
            >
              <Editing
                mode="cell"
                allowUpdating={mode !== Mode.Lecture}
                allowDeleting={mode !== Mode.Lecture}
                allowAdding={mode !== Mode.Lecture}
                newRowPosition={"first"}
                startEditAction={"click"}
              />
              {/* <SearchPanel visible={true} highlightCaseSensitive={true} /> */}
              <Column dataField={"idPlanEntete"} caption="Plan"
                dataType="string">
                <Lookup {...planForfaitEditorOptions} />
              </Column>
              <Column width={75} dataField={"actif"} dataType="boolean" caption="Actif" />
              <Column width={120} dataField={"ordreAffichage"} dataType="number" caption="Ordre d'affichage" />
              <Column dataField="isDeleted" dataType="boolean" visible={false} />
              <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
              <Paging defaultPageSize={10} />
            </DataGrid>
          </TabItem>
          <TabItem title="Périodes avec durée de réservation minimum">
            <div style={{ display: "flex" }}>
              <div style={{ width: "60%" }}>
                <DataGrid
                  // keyExpr="idTypeUnite"
                  // width={'75%'}
                  // dataSource={dataPeriode}
                  rowAlternationEnabled={true}
                  allowColumnResizing={true}
                  showBorders={true}
                  dataSource={selectedTypeUnite.periodes}
                  allowColumnReordering={false}
                  filterValue={dataGridFilterValue}
                  height={"100%"}
                  noDataText={"Aucune plage horaire"}
                  onInitNewRow={(e: any) => {
                    e.data.idTypeUnite = selectedTypeUnite.idTypeUnite;
                    e.data.isDeleted = false;
                  }}
                  onEditorPreparing={(e: any) => {
                    const originalOnValueChanged = e.editorOptions.onValueChanged;
                    e.editorOptions.onValueChanged = (args: any) => {
                      if (originalOnValueChanged) {
                        originalOnValueChanged(args);
                      }

                      const currentData = e.component.option("dataSource");
                      const rowIndex = e.rowIndex;
                      const rowData = currentData[rowIndex];

                      const updatedData = currentData.filter((_: any, index: any) => index !== rowIndex);
                      setSelectedDataRow(prev => ({
                        ...prev,
                        periodes: updatedData
                      }));
                      setIsFieldModifier(true);
                    };
                  }}
                  onRowRemoving={async (e) => {
                    e.cancel = true;
                    const index = selectedTypeUnite.periodes.findIndex(item =>
                      item.idTypeUniteReservationDureeMinimum && e.data.idTypeUniteReservationDureeMinimum && item.idTypeUniteReservationDureeMinimum.equals(e.data.idTypeUniteReservationDureeMinimum)
                    );
                    if (index !== -1) {
                      const updatedData = [...selectedTypeUnite.periodes];
                      updatedData[index] = { ...updatedData[index], isDeleted: true };
                      setSelectedDataRow(prev => ({
                        ...prev,
                        periodes: updatedData
                      }));
                    }
                  }}
                >
                  <Editing
                    mode="cell"
                    allowUpdating={mode !== Mode.Lecture}
                    allowDeleting={mode !== Mode.Lecture}
                    allowAdding={mode !== Mode.Lecture}
                    newRowPosition={"first"}
                    startEditAction={"click"}
                  />
                  <Column dataField="Si vous cochez *Rés. incluse dans période*, les dates de la réservation devront inclure la période indiquée dans cette table" groupIndex={0} />
                  <Column dataField={"dateDebut"} dataType={"date"} format={"dd-MM-yyyy"} caption="Date de début" />
                  <Column dataField={"dateFin"} dataType={"date"} format={"dd-MM-yyyy"} caption="Date de fin" />
                  {/* <Column dataField={"dureeMinimum"} dataType={"number"}
                    caption="Nb. nuitées minimum" alignment={"left"}>
                  </Column> */}
                  <Column dataField={"dureeMinimum"} dataType={"number"}
                    editorOptions={dureePlageHoraireEditorOptions}
                    caption="Nb. nuitées minimum" alignment={"left"}>
                  </Column>
                  <Column dataField={"reservationIncluePeriodeIndiquee"} dataType={"boolean"} caption="Rés. incluse dans période" />
                  <Column dataField="isDeleted" dataType="boolean" visible={false} />
                </DataGrid>
              </div>
            </div>
          </TabItem>
          <TabItem title="Internet">
            <Form readOnly={mode === Mode.Lecture}
              alignItemLabelsInAllGroups={false} formData={selectedTypeUnite || {} as ITypeUnite} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
              <GroupItem colCount={5}>
                <GroupItem colSpan={1}>
                  <SimpleItem key={"frm-description-web-fr"}>
                    <Label text={"Description web français"} />
                  </SimpleItem>
                  <GroupItem>
                    <SimpleItem key={"frm-description-web"} dataField={"descriptionWeb"} editorType={"dxTextArea"}
                      editorOptions={descriptionWebOptions}>
                      <Label visible={false} />
                    </SimpleItem>
                  </GroupItem>
                  <SimpleItem key={"frm-description-web-en"}>
                    <Label text={"Description web anglais"} />
                  </SimpleItem>
                  <GroupItem>
                    <SimpleItem key={"frm-description-web-en"} dataField={"descriptionWebAnglaise"} editorType={"dxTextArea"}
                      editorOptions={descriptionWebOptions}>
                      <Label visible={false} />
                    </SimpleItem>
                  </GroupItem>
                </GroupItem>

                <GroupItem colSpan={4}>
                  <GroupItem>
                    <SimpleItem cssClass='small-content' key={"frm-disponibleEnLigne"} dataField={"disponibleEnLigne"} editorType={"dxCheckBox"}>
                      <Label location='right' text={"Disponible pour la réservation en ligne"} />
                    </SimpleItem>
                    <SimpleItem cssClass='small-content' key={"frm-afficherUnites"} dataField={"afficherUnites"} editorType={"dxCheckBox"}>
                      <Label location='right' text={"Afficher les unités (au lieu de réserver automatiquement les premières unités disponibles trouvées)"} />
                    </SimpleItem>
                    <SimpleItem cssClass='small-content' key={"frm-afficherCalendrierEnLigne"} dataField={"afficherCalendrierEnLigne"} editorType={"dxCheckBox"}>
                      <Label location='right' text={"Permettre d'afficher un calendrier de disponibilités pour les unités de ce type"} />
                    </SimpleItem>
                    <SimpleItem cssClass='small-content' key={"frm-utiliserForfaitsPourCategoriesEtUnites"} dataField={"utiliserForfaitsPourCategoriesEtUnites"} editorType={"dxCheckBox"}>
                      <Label location='right' text={"Utiliser les forfaits de ce type d'unité pour ses catégories et ses unités (sauf si elles ont leurs propres forfaits définis)"} />
                    </SimpleItem>
                    <SimpleItem cssClass='small-content' key={"frm-Dispo"} dataField={"maxUnitesReservationEnLigne"} editorType={"dxCheckBox"} editorOptions={maxUnitesReservationOptions}>
                      <Label location='right' text={"Limiter le nombre d'unités pouvant être réservées en ligne pour ce type d'unité"} />
                    </SimpleItem>
                    <SimpleItem cssClass='small-content' key={"frm-limite"} dataField={""} editorType={"dxCheckBox"}>
                      <Label location='right' text={"Limiter les locations a une personne par unité"} />
                    </SimpleItem>
                    <SimpleItem cssClass='small-content' key={"frm-afficherCarteEnLigne"} dataField={"afficherCarteEnLigne"} editorType={"dxCheckBox"}>
                      <Label location='right' text={"Afficher une carte au lieu d'une liste d'unités pour la réservation en ligne"} />
                    </SimpleItem>
                    <SimpleItem cssClass='small-content' key={"frm-afficherInfoTerrain"} dataField={"afficherInfoTerrain"} editorType={"dxCheckBox"}>
                      <Label location='right' text={"Afficher les informations du terrain"} />
                    </SimpleItem>
                  </GroupItem>

                  <SimpleItem
                    cssClass='medium-label'
                    key={"frm-termes"}
                    dataField={"idTermeEtCondition"}
                    editorType={"dxSelectBox"}
                    editorOptions={termesEtConditions}>
                    <Label text={"Termes et conditions"} />
                  </SimpleItem>
                  <SimpleItem key={"frm-svg"} dataField={"svgImage"}
                    cssClass='medium-label'
                    editorOptions={svgOptions}>
                    <Label text={"Nom du fichier SVG à utiliser en ligne pour la carte"} />
                  </SimpleItem>

                  <GroupItem caption="Disponibilité">
                    <SimpleItem>
                      <Label text={`Les dates définies dans l'onglet "Informations" font également effet. Ces deux dates permettent d'être plus spécifique sur internet pour ce type d'unité.`} />
                    </SimpleItem>
                  </GroupItem>

                  <GroupItem colCount={2}>
                    <SimpleItem cssClass='medium-label' key={"frm-dateDebut1"} dataField={"calDateDebut"} editorType={"dxDateBox"}
                      editorOptions={calendrierEditorOptions}
                    >
                      <Label text={"Date de début"} />
                    </SimpleItem>
                    <SimpleItem cssClass='small-label' key={"frm-heureDebut2"} dataField={"calDateFin"} editorType={"dxDateBox"}
                      editorOptions={calendrierEditorOptions}
                    >
                      <Label text={"Date de fin"} />
                    </SimpleItem>
                  </GroupItem>

                  <SimpleItem>
                    <Label text={`La prochaine valeur passe avant celle définie dans la configuration des sites web (elle est toutefois ignorée si elle est 0).`} />
                  </SimpleItem>

                  <SimpleItem key={"frm-afficher"}
                    cssClass='medium-label'
                    dataField={"maxJoursAvanceInternet"} editorType={"dxNumberBox"}
                    editorOptions={maxJoursAvanceOptions}>
                    <Label text={"Les unités peuvent être réservées maximum de jours a l'avance"} />
                  </SimpleItem>


                  <GroupItem caption="Photos">
                    <GroupItem colCount={2}>
                      <SimpleItem key={"frm-uploadImg"}>
                        <FileUploader
                          disabled={mode === Mode.Lecture}
                          onValueChange={async (e) => {
                            if (e?.[0]) {
                              // if (e.value?.[0]) {
                              const file = e[0];
                              const fr = new FileReader();
                              await fr.readAsDataURL(file);
                              fr.onload = () => {
                                if (fr.result) {
                                  const base64 = fr.result.toString();
                                  setInternetPhotos(prevPhotos => [...prevPhotos, base64]);
                                }
                              };
                            } else {
                              alert("File not selected or browser incompatible.")
                            }
                          }}
                          showFileList={false}
                          selectButtonText="Ajouter une photo"
                          labelText="" accept="image/*" uploadMode="useForm"
                        />
                      </SimpleItem>
                      <SimpleItem>
                        <Button
                          style={{
                            position: 'relative',
                            top: '14px',
                            left: '-200px'
                          }}
                          disabled={mode === Mode.Lecture}
                          onClick={() => {
                            if (focusedPhoto != null && internetPhotos.length) {
                              setInternetPhotos(prevPhotos =>
                                prevPhotos.filter((_, index) => index !== focusedPhoto)
                              );
                              setFocusedPhoto(null)
                            }
                          }}
                          text="Supprimer la photo"
                        />
                      </SimpleItem>
                    </GroupItem>
                    <GroupItem>
                      {internetPhotos?.length > 0 && internetPhotos.map((e, i) => {
                        return <SimpleItem key={`gallery-${i}`}>
                          <Gallery
                            style={{
                              marginLeft: '10px'
                            }}
                            disabled={mode === Mode.Lecture}
                            className='gestion-types-unites-image'
                            dataSource={[e]}
                            noDataText='Pas de données image'
                            width={135}
                            height={100}
                            showIndicator={false}
                            onItemClick={(e) => {
                              setFocusedPhoto(i);
                            }}
                          />
                        </SimpleItem>
                      })}
                    </GroupItem>
                  </GroupItem>
                  <GroupItem caption="Jours de réservations">
                    <DataGrid
                      width={500}
                      height={250}
                      rowAlternationEnabled={true}
                      showBorders={true}

                      allowColumnResizing={true}
                      dataSource={selectedTypeUnite.joursReservations}
                      allowColumnReordering={false}
                      filterValue={dataGridFilterValue}
                      noDataText={""}
                      onInitNewRow={(e: any) => {
                        e.data.idTypeUnite = selectedTypeUnite.idTypeUnite;
                        e.data.isDeleted = false;
                      }}
                      onEditorPreparing={(e: any) => {
                        const originalOnValueChanged = e.editorOptions.onValueChanged;
                        e.editorOptions.onValueChanged = (args: any) => {
                          if (originalOnValueChanged) {
                            originalOnValueChanged(args);
                          }

                          const currentData = e.component.option("dataSource");
                          const rowIndex = e.rowIndex;
                          const rowData = currentData[rowIndex];

                          const updatedData = currentData.filter((_: any, index: any) => index !== rowIndex);
                          setSelectedDataRow(prev => ({
                            ...prev,
                            joursReservations: updatedData
                          }));
                          setIsFieldModifier(true);
                        }
                      }}
                      onRowRemoving={async (e) => {
                        e.cancel = true;
                        // if (e?.data?.idPermisType) {
                        const index = selectedTypeUnite.joursReservations.findIndex(item =>
                          item.idTypeUniteJoursReservation && e.data.idTypeUniteJoursReservation && item.idTypeUniteJoursReservation.equals(e.data.idTypeUniteJoursReservation)
                        );
                        if (index !== -1) {
                          const updatedData = [...selectedTypeUnite.joursReservations];
                          updatedData[index] = { ...updatedData[index], isDeleted: true };
                          setSelectedDataRow(prev => ({
                            ...prev,
                            joursReservations: updatedData
                          }));
                        }
                        // }
                      }}
                    >
                      <Editing
                        mode="cell"
                        allowUpdating={mode !== Mode.Lecture}
                        allowDeleting={mode !== Mode.Lecture}
                        allowAdding={mode !== Mode.Lecture}
                        newRowPosition={"first"}
                        startEditAction={"click"}
                      />
                      <Column
                        caption="Jour début"
                        dataType='number'
                        dataField="jourDebut"
                        editorOptions={joursEditorOptions}
                      >
                        <Lookup {...joursEditorOptions} />
                      </Column>
                      <Column
                        caption="Jour fin"
                        dataType='number'
                        dataField="jourFin"
                      // editorOptions={joursEditorOptions}
                      // lookup={{
                      //   dataSource: jours,
                      //   displayExpr: "text",
                      //   valueExpr: "id",
                      // }}
                      >
                        {/* <Lookup {...joursEditorOptions} /> */}
                      </Column>
                      <Column
                        caption="Durée (jours)"
                        dataType='number'
                        dataField='dureeMinimum'
                        editorOptions={spinOptions2}
                      />
                      <Column dataField="isDeleted" dataType="boolean" visible={false} />
                    </DataGrid>
                  </GroupItem>
                </GroupItem>
              </GroupItem>
            </Form>
          </TabItem>
          <TabItem title="Système">
            <FormSysteme formData={selectedTypeUnite || {} as ITypeUnite} />
          </TabItem>
        </FormListBaseTab> : null
      }
    </FormListBase>
  );
}